import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";


import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
  validaMonto,
  formatoMonto,
  formatMoneda,
} from "../../../util/varios";
import axios from "axios";
import moment from "moment";

import { Dimmer } from "../../spinner";

export const ImpSectorInmueblesUrbanos = (props) => {
  /*  variables de estados */

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [tecla, setTecla] = useState();
  const [anio, setAnio] = useState();
  const [visibleF, setVisibleF] = useState("hidden");
  const [visibleA, setVisibleA] = useState("hidden");
  const radioTodasFecha = useRef();
  const radioSeleccionarFecha = useRef();
  const txtMonto = useRef();

  const cmbTipCont = useRef("");
  const cmbAnio = useRef("");
  const txtSectorDesde = useRef();
  const txtSectorHasta = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  const chkActivo = useRef();
  const chkInactivo = useRef();
  const chkProceso = useRef();
  const chkClausurado = useRef();
  const chkFiscal = useRef();
  const chkNotificado = useRef();
  const chkDepLegal = useRef();
  const chkExonerado = useRef();
  const chkRevCerrado = useRef();
  const txtCodActividad = useRef();
  const txtDescripcionActi = useRef();
  const chkAnterior = useRef();
  const chkActual = useRef();
  const cmbTipo = useRef();
  const [tipoConstruccion, setTipoConstruccion] = useState("");

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
      event.target.value = '0,00'
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }


    // Devuelve el número formateado
    let e = event.target.value.replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, '$1.$2')
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e)
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    var nanio = [];
    var aini = parseInt(obj.anioactu) - 7;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }
    setAnio(nanio);
  }, []);

  let op = require("../../../../src/modulos/datos");

  const handleCloseSi = () => {
    setMostrar1(false);
    var reporte = "ListGenxActiv";
    var sql = "";
    var sql2 = "";
    var sql3 = "";
    var sql4 = "";
    var condicion = "";
    if (radioTodasFecha.current.checked) {
      sql = "  ACT.anios = " + cmbAnio.current.value;
    } else {
      sql =
        "  ACT.codigoactividad = '" +
        txtCodActividad.current.value +
        "' AND ACT.anios = " +
        cmbAnio.current.value;
    }
    sql4 = "Según la Actividad Económica y el SECTOR";
    sql2 = "";
    condicion = sql;
    window.open(
      op.reportes + "/inmueblesurbanos?" +
      "reporte=" +
      reporte +
      "&CONDICION=" +
      condicion +
      "&TIT_RGO1=" +
      sql2 +
      "&ORDEN=" +
      sql3 +
      "&TIT_ADICIONAL=" +
      sql4,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const handleCloseNo = () => {
    setMostrar1(false);
    var reporte = "ListGenxActiv1";
    var sql = "";
    var sql2 = "";
    var sql3 = "";
    var sql4 = "";
    var condicion = "";
    if (radioTodasFecha.current.checked) {
      sql = "  ACT.anios = " + cmbAnio.current.value;
    } else {
      sql =
        "  ACT.codigoactividad = '" +
        txtCodActividad.current.value +
        "' AND ACT.anios = " +
        cmbAnio.current.value;
    }
    sql4 = "Según la Actividad Económica y el SECTOR";
    sql2 = "";
    condicion = sql;
    window.open(
      op.reportes + "/inmueblesurbanos?" +
      "reporte=" +
      reporte +
      "&CONDICION=" +
      condicion +
      "&TIT_RGO1=" +
      sql2 +
      "&ORDEN=" +
      sql3 +
      "&TIT_ADICIONAL=" +
      sql4,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaDesde.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
          setMostrar(true);
          //txtFechaDesde.current.value = txtFechaHasta.current.value;
        } else {
          txtFechaHasta.current.focus();
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaHasta.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de fin no puede ser inferior a la fecha de inicio.");
          setMostrar(true);
          //txtFechaHasta.current.value = txtFechaDesde.current.value;
        } else {
          if (props.tiporep === "1") {
            cmbTipCont.current.focus();
          } else if (props.tiporep === "2") {
            btnAcepta.current.focus();
          }
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaDesde.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
          setMostrar(true);
          //txtFechaDesde.current.value = txtFechaHasta.current.value;
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaHasta.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
          setMostrar(true);
          //txtFechaDesde.current.value = txtFechaHasta.current.value;
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.id === "inputSectorDesde") {
        txtSectorDesde.current.value = txtSectorDesde.current.value
          .toString()
          .trim()
          .padStart(2, 0);
        if (
          txtSectorDesde.current.value > txtSectorHasta.current.value &&
          txtSectorDesde.current.value !== "" &&
          txtSectorHasta.current.value !== ""
        ) {
          setTitulo("Error");
          setMsg(
            "El Rango no es Valido, El Rango 'Desde' es Mayor que el Rango 'Hasta'."
          );
          setMostrar(true);
        } else {
          if (event.which === 13) {
            txtSectorHasta.current.focus();
          }
        }
      } else if (event.target.id === "inputSectorHasta") {
        txtSectorHasta.current.value = txtSectorHasta.current.value
          .toString()
          .trim()
          .padStart(2, 0);
        if (
          txtSectorDesde.current.value > txtSectorHasta.current.value &&
          txtSectorDesde.current.value !== "" &&
          txtSectorHasta.current.value !== ""
        ) {
          setTitulo("Error");
          setMsg(
            "El Rango no es Valido, El Rango 'Desde' es Mayor que el Rango 'Hasta'."
          );
          setMostrar(true);
        } else {
          if (event.which === 13) {
            radioTodasFecha.current.focus();
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const imprimirReporte = () => {
    console.log('hola si lego ')
    var sigue = true;
    if (txtSectorDesde.current && txtSectorDesde.current.value.trim() === "") {
      console.log('hola si lego 1')
      setTitulo("Error");
      setMsg("El Sector Desde no debe estar vacio");
      sigue = false;
      txtSectorDesde.current.focus();
    } else if (!chkActivo.current.checked && !chkInactivo.current.checked && !chkProceso.current.checked) {
      console.log('hola si lego 2')
      setTitulo("Error");
      setMsg("Debe Seleccionar un Estatus");
      sigue = false;
    } else if (tipoConstruccion === "" && props.tiporep === "3") {
      console.log('hola si lego 3')
      setTitulo("Error");
      setMsg("Debe Seleccionar un Tipo de Construccion");
      sigue = false;
    }

    if (sigue) {
      var reporte = "";
      var sql = "";
      var sql1 = "";
      var sql2 = "";
      var sql3 = "";
      var tipo = "";
      var crit = "";
      var crite = "";
      var val0 = "";
      var val1 = "";
      var status = "";
      console.log(props.tiporep)

      if (props.tiporep === "1") {
        console.log('props.tiporep === "1"')

        reporte = "ListGenInmueble";
        var a = chkActivo.current.checked ? "61," : "0,";
        var i = chkInactivo.current.checked ? "62," : "0,";
        var c = chkProceso.current.checked ? "63" : "0";
        var status_cade = a + i + c;

        if (chkAnterior.current.checked) {
          sql =
            "(substr(codigoanterior,7,2) between" +
            " '" +
            txtSectorDesde.current.value.trim() +
            "' " +
            "and" +
            " '" +
            txtSectorHasta.current.value.trim() +
            "' " +
            ")";
          sql2 =
            "Desde Sector:" +
            txtSectorDesde.current.value.trim() +
            "  " +
            "Hasta Sector:" +
            txtSectorHasta.current.value.trim();

          sql3 = " AND status IN (" + status_cade + ")";

          tipo = 1;
        } else if (chkActual.current.checked) {
          sql =
            "(substr(codigocatastral,10,3) between" +
            " '" +
            txtSectorDesde.current.value.trim() +
            "' " +
            "and" +
            " '" +
            txtSectorHasta.current.value.trim() +
            "' " +
            ")";
          sql2 =
            "Desde Sector:" +
            txtSectorDesde.current.value.trim() +
            "  " +
            "Hasta Sector:" +
            txtSectorHasta.current.value.trim();

          sql3 = " AND status IN (" + status_cade + ")";

          tipo = 2;
        }
        window.open(
          op.reportes + "/inmueblesurbanos?" +
          "reporte=" +
          reporte +
          "&sql=" +
          sql +
          "&sql2=" +
          sql2 +
          "&sql3=" +
          sql3 +
          "&tipo=" +
          tipo,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else if (props.tiporep === "2") {
        console.log('props.tiporep === "2"')

        reporte = "ListGenInmuebleAvaluo";
        var a = chkActivo.current.checked ? "61," : "0,";
        var i = chkInactivo.current.checked ? "62," : "0,";
        var c = chkProceso.current.checked ? "63" : "0";
        var status_cade = a + i + c;

        if (chkAnterior.current.checked) {
          crit = "V";

          tipo = 1;

          crite =
            "(substr(codigoanterior,7,2) between" +
            " ' " +
            txtSectorDesde.current.value.trim() +
            " ' " +
            " and " +
            " '" +
            txtSectorHasta.current.value.trim() +
            " ' " +
            ")";
        } else if (chkActual.current.checked) {
          crit = "N";

          tipo = 2;

          crite =
            "(substr(codigocatastral,10,3) between" +
            " ' " +
            txtSectorDesde.current.value.trim() +
            "' " +
            " and " +
            " ' " +
            txtSectorHasta.current.value.trim() +
            " ' " +
            ")";
        }

        val0 = txtMonto.current.value.replace(/\./g, "");

        val1 = val0.replace(".", ",");

        sql =
          crite + "and (valorterreno+valorconstruccion)>=" + parseFloat(val1);

        console.log(val1);

        sql1 = crit;

        sql2 =
          "Desde Sector:" +
          txtSectorDesde.current.value.trim() +
          "  " +
          "Hasta Sector:" +
          txtSectorHasta.current.value.trim();

        status = " AND status IN (" + status_cade + ")";

        window.open(
          op.reportes + "/inmueblesurbanos?" +
          "reporte=" +
          reporte +
          "&sql=" +
          encodeURIComponent(sql) +
          "&sql1=" +
          encodeURIComponent(sql1) +
          "&sql2=" +
          encodeURIComponent(sql2) +
          "&sql3=" +
          encodeURIComponent(sql3) +
          "&tipo=" +
          encodeURIComponent(tipo),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else if (props.tiporep === "3") {
        console.log('props.tiporep === "3"')

        reporte = "ListGenInmuebleTipoCon";
        var a = chkActivo.current.checked ? "61," : "0,";
        var i = chkInactivo.current.checked ? "62," : "0,";
        var c = chkProceso.current.checked ? "63" : "0";
        var status_cade = a + i + c;

        if (chkAnterior.current.checked) {
          crit = "V";

          tipo = 1;

          crite =
            "(substr(codigoanterior,7,2) between" +
            " '" +
            txtSectorDesde.current.value.trim() +
            "' " +
            "and" +
            " '" +
            txtSectorHasta.current.value.trim() +
            "' " +
            ")";
        } else if (chkActual.current.checked) {
          crit = "N";

          tipo = 2;

          crite =
            "(substr(codigocatastral,10,3) between" +
            " '" +
            txtSectorDesde.current.value.trim() +
            "' " +
            "and" +
            " '" +
            txtSectorHasta.current.value.trim() +
            "' " +
            ") ";
        }

        sql = crite + " and tipoconstruccion =" + "'" + tipoConstruccion + "'";

        sql1 = crit;

        sql2 =
          "Desde Sector:" +
          txtSectorDesde.current.value.trim() +
          "  " +
          "Hasta Sector:" +
          txtSectorHasta.current.value.trim();

        sql3 = " AND status IN (" + status_cade + ")";

        window.open(
          op.reportes + "/inmueblesurbanos?" +
          "reporte=" +
          reporte +
          "&sql=" +
          sql +
          "&sql1=" +
          sql1 +
          "&sql2=" +
          sql2 +
          "&sql3=" +
          sql3 +
          "&tipo=" +
          tipo,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else if (props.tiporep === "4") {
        console.log('props.tiporep === "4"')

        reporte = "ListGenInmuebleDeuda";
        var a = chkActivo.current.checked ? "61," : "0,";
        var i = chkInactivo.current.checked ? "62," : "0,";
        var c = chkProceso.current.checked ? "63" : "0";
        var status_cade = a + i + c;

        if (chkAnterior.current.checked) {
          crit = "V";

          tipo = 1;

          crite =
            "(substr(codigoanterior,7,2) between" +
            " '" +
            txtSectorDesde.current.value.trim() +
            "' " +
            "and" +
            " '" +
            txtSectorHasta.current.value.trim() +
            "' " +
            ")";
        } else if (chkActual.current.checked) {
          crit = "N";

          tipo = 2;

          crite =
            "(substr(codigocatastral,10,3) between" +
            " '" +
            txtSectorDesde.current.value.trim() +
            "' " +
            "and" +
            " '" +
            txtSectorHasta.current.value.trim() +
            "' " +
            ")";
        }

        val0 = txtMonto.current.value.replace(/\./g, "");

        val1 = val0.replace(",", ".");

        sql = crite + " and DEU_MTOPEN >= " + val1;

        sql1 = crit;

        sql2 =
          "Desde Sector:" +
          txtSectorDesde.current.value.trim() +
          "  " +
          "Hasta Sector:" +
          txtSectorHasta.current.value.trim();

        sql3 = " AND status IN (" + status_cade + ")";

        window.open(
          op.reportes + "/inmueblesurbanos?" +
          "reporte=" +
          reporte +
          "&sql=" +
          sql +
          "&sql1=" +
          encodeURIComponent(sql1) +
          "&sql2=" +
          encodeURIComponent(sql2) +
          "&sql3=" +
          encodeURIComponent(sql3) +
          "&tipo=" +
          encodeURIComponent(tipo),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }

    } else {
      setMostrar(true);
    }
  };

  const captureType = (e) => {
    setTipoConstruccion(e.target.value);
  };
  const blanquear = () => {
    txtSectorDesde.current.value = "";
    txtSectorHasta.current.value = "";
    chkActivo.current.checked = false;
    chkInactivo.current.checked = false;
    if (txtMonto.current) {
      txtMonto.current.value = "";

    }
    if (cmbTipo.current) {
      cmbTipo.current.value = "";

    }
    chkProceso.current.checked = false;

  }

  const cancelar = () => {
    blanquear()
  };

  const salir = (e) => {
    e.preventDefault();
    props.onHideCancela();
    blanquear();
  };



  const catalogoActi = () => {
    setMostrar2(true);
  };

  const handleCloseCatalogoActi = () => {
    setMostrar2(false);
  };

  const handleAceptaCatalogoActi = (
    idActi,
    codciu,
    codacti,
    descrip,
    alicuo,
    mini
  ) => {
    setMostrar2(false);
    txtCodActividad.current.value = codacti;
    txtDescripcionActi.current.value = descrip.trim();
    btnAcepta.current.focus();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setContar1(0);
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>{props.titulo1}</Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate} >
        </Dimmer>
        <div style={{ height: "auto", overflow: "auto" }}>
          <h2 style={{ textAlign: "center" }}>{props.titulo2}</h2>

          <div className="row col-md-12 py-0 d-flex justify-content-start">
            <div className="col-md-2" style={{ margin: 0, padding: 0 }}>
              <label>Buscar por: </label>
            </div>

            <div class="form-check col-md-3">
              <input
                className="form-check-input"
                type="radio"
                defaultChecked={true}
                name="radioFecha"
                value="1"
                id="radioSi"
                ref={chkAnterior}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Código Anterior
              </label>
            </div>

            <div class="form-check col-md-3">
              <input
                className="form-check-input"
                type="radio"
                name="radioFecha"
                value="2"
                id="radioNo"
                ref={chkActual}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                Código Actual
              </label>
            </div>
          </div>

          <hr />
          <div
            className="row col-md-11 mx-auto"
            style={{ marginBottom: "10px", padding: 0, margin: 0 }}
          >
            <div class="input-group input-group-sm mb-3 col-md-5">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Desde el Sector Catastral N°
              </span>
              <input
                type="text"
                autoComplete="off"
                ref={txtSectorDesde}
                maxLength={3}
                className="form-control form-control-sm "
                id="inputSectorDesde"
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
              />
            </div>
            <div className="col-md-2"></div>
            <div class="input-group input-group-sm mb-3 col-md-5">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Hasta el Sector Catastral N°
              </span>
              <input
                type="text"
                autoComplete="off"
                ref={txtSectorHasta}
                maxLength={3}
                className="form-control form-control-sm "
                id="inputSectorHasta"
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
              />
            </div>
          </div>

          {props.tiporep === "2" ? (
            <div class="input-group input-group-sm aling-items-start mb-3 col-md-5 align-self-end">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Monto del Avaluo Mayor o Igual
              </span>
              <input
                ref={txtMonto}
                type="text"
                autoComplete="off"
                className="form-control form-control-sm "
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
              />
            </div>
          ) : (
            " "
          )}

          {props.tiporep === "3" ? (
            <div>
              <div class="input-group input-group-sm mb-3 col-md-5">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  Tipo de Construcción
                </span>
                <select
                  name="idavaluo"
                  value={tipoConstruccion}
                  ref={cmbTipo}
                  className="form-control col-md-7 top-0"
                  id="inputFechaReg"
                  onChange={captureType}
                >
                  <option value={""}>...</option>
                  <option value={"QUINTA"}>QUINTA</option>
                  <option value={"CASA-QUINTA"}>CASA-QUINTA</option>
                  <option value={"CHALET"}>CHALET</option>
                  <option value={"TOWN HOUSE"}>TOWN HOUSE</option>
                  <option value={"CASA TRADICIONAL"}>CASA TRADICIONAL</option>
                  <option value={"CASA CONVENCIONAL"}>CASA CONVENCIONAL</option>
                  <option value={"CASA ECONOMICA"}>CASA ECONOMICA</option>
                  <option value={"RANCHO"}>RANCHO</option>
                  <option value={"EDIFICIO"}>EDIFICIO</option>
                  <option value={"APARTAMENTO"}>APARTAMENTO</option>
                  <option value={"CENTRO COMERCIAL"}>CENTRO COMERCIAL</option>
                  <option value={"LOCAL COMERCIAL"}>LOCAL COMERCIAL</option>
                  <option value={"CALPON"}>GALPON</option>
                  <option value={"VAQUERAS"}>VAQUERAS</option>
                  <option value={"COCHINERAS"}>COCHINERAS</option>
                  <option value={"CORRALES Y ANEXOS"}>CORRALES Y ANEXOS</option>
                  <option value={"DEBERES"}>BEBEDEROS</option>
                  <option value={"COMEDEROS"}>COMEDEROS</option>
                  <option value={"TANQUES"}>TANQUES</option>
                </select>
              </div>
            </div>
          ) : (
            " "
          )}

          {props.tiporep === "4" ? (
            <div class="input-group input-group-sm mb-3 col-md-6">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Monto de la Deuda Mayor o Igual
              </span>
              <input
                type="text"
                ref={txtMonto}
                autoComplete="off"
                className="form-control form-control-sm text-right "
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
              />
            </div>
          ) : (
            " "
          )}

          <div className="row col-md-12 d-flex justify-content-center">
            <div class="form-check col-md-2">
              <input
                type="checkbox"
                className="mx-1"
                id="chkActiviEconoConsul"
                name="accactividad"
                ref={chkActivo}
              />
              <label class="form-check-label" for="defaultCheck1">
                Activo
              </label>
            </div>

            <div class="form-check col-md-2">
              <input
                type="checkbox"
                className="mx-1"
                id="chkActiviEconoConsul"
                name="accactividad"
                ref={chkInactivo}
              />
              <label class="form-check-label" for="defaultCheck1">
                Inactivo
              </label>
            </div>

            <div class="form-check col-md-3">
              <input
                type="checkbox"
                className="mx-1"
                id="chkActiviEconoConsul"
                name="accactividad"
                ref={chkProceso}
              />
              <label class="form-check-label" for="defaultCheck1">
                En Proceso
              </label>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-primary btn-sm rounded-circle"
          title="Imprimir Reporte"
        >
          <i className="fas fa-print"></i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-secondary  btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-ban"> Cancelar</i>
        </button>
        <button
          /* ref={btnSalir}  */ onClick={salir}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fa fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
